package com.dotdrives.client

import com.dotdrives.model.RecurringSchedulePage
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.postgrest.postgrest
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put

class RecurringScheduleClient(private val client: SupabaseClient = SupabaseProvider.client) {
    suspend fun list(orgId: String, giverId: String?, status: String, query: String, offset: Int, limit: Int): RecurringSchedulePage =
        client.postgrest.rpc("recurring_schedules", buildJsonObject {
            put("p_org", orgId)
            giverId?.let { put("p_giver", it) }
            put("p_status", status)
            put("p_query", query.trim())
            put("p_offset", offset)
            put("p_limit", limit)
        }).decodeAs()
}
